// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jZnG","content":"styles_content__2E43x"};